// 🔒 PROTECTED — PricePAL Compare
// Owner: Garry Yee | Do not modify without explicit written permission
// See /app/PROTECTED_CODE_REGISTRY.md for full rules
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Cookie Consent Banner — Slim, non-intrusive
 * Required by UK PECR (Privacy and Electronic Communications Regulations)
 * Shows on first visit, remembers choice in localStorage.
 */
const CookieConsentBanner = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookie_consent', 'all');
    localStorage.setItem('cookie_preferences', JSON.stringify({
      necessary: true,
      functional: true,
      analytics: true,
      marketing: true,
    }));
    setVisible(false);
  };

  const handleEssentialOnly = () => {
    localStorage.setItem('cookie_consent', 'essential');
    localStorage.setItem('cookie_preferences', JSON.stringify({
      necessary: true,
      functional: false,
      analytics: false,
      marketing: false,
    }));
    setVisible(false);
  };

  const handleManage = () => {
    navigate('/cookies');
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-16 left-3 right-3 z-[40] bg-white border border-gray-200 rounded-xl shadow-lg px-4 py-3 sm:left-auto sm:right-4 sm:max-w-sm"
      role="dialog"
      aria-label="Cookie consent"
      aria-describedby="cookie-consent-description"
      style={{ animation: 'slideUp 0.3s ease-out' }}
    >
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <p id="cookie-consent-description" className="text-xs text-gray-500 mb-2.5 leading-relaxed">
        We use cookies to improve your experience.{' '}
        <button
          onClick={handleManage}
          className="text-green-600 underline font-medium hover:text-green-700"
        >
          Learn more
        </button>
      </p>
      <div className="flex gap-2">
        <button
          onClick={handleEssentialOnly}
          className="flex-1 px-3 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
          data-testid="cookie-essential-btn"
        >
          Essential Only
        </button>
        <button
          onClick={handleAcceptAll}
          className="flex-1 px-3 py-1.5 text-xs font-semibold text-white bg-green-600 rounded-lg hover:bg-green-700 transition"
          data-testid="cookie-accept-btn"
        >
          Accept All
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
